/**
 * t: current time（当前时间）；
 * b: beginning value（初始值）；
 * c: change in value（变化量）；
 * d: duration（持续时间）。
 */
export const tween = {
    easeOut: {
        easeOutQuad (t, b, c, d) {
            return -c * (t /= d) * (t - 2) + b;
        }
    },
    linear (t, b, c, d) {
        return b + (c / d) * t;
    }
};

/**
 * @param {Number} b beginning value (初始值)
 * @param {Number} c change in value (变化量)
 * @param {Number} d duration (持续时间)
 * @param {Function} cb callback (回调函数) 不支持异步
 * @param {Function} f timing-function (缓动函数)
 */

export const run = function (b, c, d, cb, f) {
    const animMetaData = {
        continueRun: true
    };
    const anim = new Promise(function (resolve, reject) {
        var t = Date.now();
        const timeFunc = f || tween.easeOut.easeOutQuad;
        function step () {
            const T = (Date.now() - t) / 1000;
            const C = timeFunc(T, b, c, d);
            if (C >= c || T >= d) {
                const result = cb(C, true);
                resolve(result);
                return;
            }
            const result = cb(C, false);
            if (animMetaData.continueRun) {
                requestAnimationFrame(step);
            } else {
                resolve(result);
            }
        }
        step();
    }).catch(err => {
        console.log(err);
        return Promise.resolve();
    });
    anim.stopAnimation = function () {
        animMetaData.continueRun = false;
    };
    return anim;
};

export default { run };



// WEBPACK FOOTER //
// ./src/assets/js/common/animation/animation.js